export default {
  computed: {
    activeComponentIsNotUgc() {
      return !this.$recipe.getUGCFeatureType(this.activeComponent);
    },
    selectedSwatch() {
      return this.$store.state.swatches.selectedSwatches[this.activeComponent];
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    activeComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
  },
  methods: {
    /**
     * Checks if the feature exists as a substring in the PDMs
     * Geometry Updates OR Mercandising Rules
     *
     * @param {String} feature The UGC feature subgroup eg: "crayola"
     * @param {String} searchType ("geometry_updates" || "merchandising_rules")
     * @returns {Array} The geometry update or merchandising rule key
     * e.g: ["crayola_logo"]
     */
    getFeatureGeometryPdmKey({feature, searchType}) {
      if (searchType === "geometry_updates" || searchType === "merchandising_rules") {
        const geometryUpdates = this.pdm && this.pdm[searchType] && this.pdm[searchType].swatches;
        return Object.keys(geometryUpdates).filter(name => name.includes(feature));
      }
    },

    /**
     * Validates if the feature UGC geometry exists in the recipe component
     * @param {String} - componentName
     * @param {String} - feature Matching the UGC Feature to get Geometry Updates
     * @returns {Boolean}
     */
    isValidFeatureGeoUpdate({componentName, feature}) {
      const recipeComponents = this.recipe_v2.components[componentName];
      const availableUgcFeatures = this.$store.state.ugc.availableUgcFeatures;

      if(recipeComponents.subgroup === feature && availableUgcFeatures.includes(feature)) {
        const isFeatureInGeometryUpdates = this.getFeatureGeometryPdmKey({feature, searchType: "geometry_updates"});
        const isFeatureInMerchRules = this.getFeatureGeometryPdmKey({feature, searchType: "merchandising_rules"});
        return isFeatureInGeometryUpdates
          && isFeatureInGeometryUpdates.length > 0
          && isFeatureInMerchRules
          && isFeatureInMerchRules.length > 0;
      }
      return false;
    },

    /**
     * Replace Default Swatch Logo with the Feature Geometry Update Logo
     * Needed because the Swatch Geometry Updates dont include the UGC Feature
     *
     * @param {String} componentName
     * @param {Array} geometrySwatch List of Swatch's geometry_updates
     * @param {String} geometryUpdate Previous Swatch Geometry Updates
     * @returns {Array} geometrySwatch with updated Geometry Updates
     */
    isGeoUpdateFromFeature({componentName, geometrySwatch, geometryUpdate}) {
      const recipeComponents = this.recipe_v2.components[componentName];
      const availableUgcFeatures = this.$store.state.ugc.availableUgcFeatures;

      if(
        (geometrySwatch && geometrySwatch.length > 0)
        && recipeComponents.group === "ugc"
        && availableUgcFeatures.includes(recipeComponents.subgroup)
        && !geometryUpdate.includes(recipeComponents.subgroup)
      ) {
        const geometryPerFeature = this.getFeatureGeometryPdmKey({feature: recipeComponents.subgroup, searchType: "geometry_updates"});
        const merchRulesPerFeature = this.getFeatureGeometryPdmKey({feature: recipeComponents.subgroup, searchType: "merchandising_rules"});
        geometrySwatch = geometrySwatch.filter(data => !data.includes("logo"));
        return geometrySwatch.concat(geometryPerFeature || merchRulesPerFeature);
      }
      return geometrySwatch;
    },

    /**
     * Applies the UGC Feature Geometry Updates
     * @param {String} geometryUpdate
     * @param {String} updateType is Optional
     *
     * @see applyUGCFeatureGeometry()
     */
    updateFeatureModelGeometry({ geometryUpdate, updateType = 'swatches' }) {
      return this.swapGeometries({ geometryUpdate, updateType });
    },

    /**
     * Reset the UGC Feature Geometry Updates to defaults
     *
     */
    resetGeometrybyUGCFeature() {
      let ugcComponents = this.$recipe.getUGCComponents();
      let isUgcFeatureComp = 0;
      let ugcFeature;
      // Restore UGC Feature when the image is replaced
      ugcComponents.forEach(component => {
        const componentRecipe = this.recipe_v2.components[component];
        ugcFeature = this.$recipe.getUGCFeatureType(component);
        if (ugcFeature !== "ugc"
           || (ugcFeature === "ugc" && componentRecipe.subgroup === "ugc") ) {
           isUgcFeatureComp++;
        }
      });

      if (isUgcFeatureComp == ugcComponents.length)
        return this.swapGeometries({ geometryUpdate: ugcFeature, updateType: "feature" });

    }
  }
};
